import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';

function HeaderBack({step, setStep, text}) {
    const navigate = useNavigate()
    return (
        <div className="header">
            {step === 0 ? (
                <span className="back" onClick={() => navigate(-1)}>
                    <ArrowBackIcon/>
                </span>
            ) : (
                <span className="back" onClick={() => setStep(step - 1)}>
                    <ArrowBackIcon/>
                </span>
            )}
            <p className='main'>{text}</p>
        </div>
    )
}

export default HeaderBack
